"use client";
import type { FeatheryFormBlock } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";

const FeatheryForm = dynamic(() => import("@/app/_components/feathery/FeatheryForm"));

type BlockFeatheryFormProps = Pick<FeatheryFormBlock, "formId" | "reset" | "title" | "width">;

export const BlockFeatheryForm = ({ title, formId, width = "contained" }: BlockFeatheryFormProps) => {
  const fullWidth = width === "full-width";
  return <FeatheryForm formId={formId} fullWidth={fullWidth} title={title} />;
};
